import { motion } from "framer-motion";
import styled from "styled-components";

// Define the styled component using `motion.div`
export const MotionDiv = styled(motion.div)`
  position: fixed;
  bottom: 80px;
  top: 85px;
  left: 0;
  right: 0;
  z-index: 10;
  height: 81%;
  background-color: #eff1fc;
`;

// Animation variants
export const slideInVariants = {
  hidden: { y: "100%", opacity: 0 },
  visible: { y: 0, opacity: 1 },
  exit: { y: "100%", opacity: 0 }
};

export const CollapseHeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 1rem;
  cursor: pointer;
  transition: color 0.3s ease;
  color: ${({ active }) => (active ? "#4056f4" : "#000")};
  font-weight: 600;
  font-size: 1.1rem;
  > svg {
    width: 1.2rem;
    height: 1.2rem;
    transition: transform 0.3s ease;
    transform: ${({ active }) => (active ? "rotate(0deg)" : "rotate(-90deg)")};
  }
  svg g path,
  div svg path {
    transition: stroke 0.3s ease;
    stroke: ${({ active }) => (active ? "#4056f4" : "#000")};
  }
`;
